import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import { ILoadingLayover } from './interfaces';

export const LoadingLayover: React.FC<ILoadingLayover> = ({ height }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={height || '100vh'}
    >
      <CircularProgress size="50px" />
    </Box>
  );
};
